/**
 * Map over items with at most so many promises waiting at once, keeping
 * their order.
 */
export async function mapLimited<Item, Result>(
  items: readonly Item[],
  limit: number,
  map: (item: Item) => Promise<Result>,
): Promise<readonly Result[]> {
  const results: Result[] = Array.from({ length: items.length });
  let next = 0;
  const worker = async (): Promise<void> => {
    while (next < items.length) {
      const at = next;
      next += 1;
      // oxlint-disable-next-line no-await-in-loop -- each worker takes the next item when its last one is done, which is what bounds the requests in flight
      results[at] = await map(items[at]!);
    }
  };
  await Promise.all(
    Array.from({ length: Math.min(limit, items.length) }, worker),
  );

  return results;
}
